import { numberFormatter } from 'utils/numberFormatter';

import { getPalletLabel } from '.';

export const getPalletAmountLabel = (palletsAmount: number) =>
   `${numberFormatter.format(palletsAmount)} ${getPalletLabel(palletsAmount)}`;
